import React from 'react';
import { Button } from 'baseui/button';
import { Select } from 'baseui/select';
import { FileUploader } from 'baseui/file-uploader';
import useUpload from './useUpload';
import { actionOptions } from '../utils';
import './style.css';

const UploadCSV: React.FC = () => {
	const { csvFile, selectedAction, handleActionChange, handleFileUpload, uploadCsvFile } = useUpload();

	return (
		<div className='upload-container'>
			<div className='file-upload-container'>
				<div className='action-selection'>
					<label htmlFor='actionDropdown' className='label-action'>
						Select action:
					</label>
					<Select
						id='actionDropdown'
						options={actionOptions}
						value={selectedAction}
						onChange={({ value }) => handleActionChange(value)}
					/>
				</div>
				<FileUploader accept={['.csv']} onDrop={(uploadedFiles) => handleFileUpload(uploadedFiles)} />
			</div>
			{csvFile && (
				<div className='uploaded-file-info'>
					<p>File: {csvFile.name}</p>
					<Button kind='primary' size='compact' onClick={uploadCsvFile} disabled={!uploadCsvFile} className='upload-button'>
						Upload
					</Button>
				</div>
			)}
		</div>
	);
};

export default UploadCSV;
